import { useEffect } from 'react';

import { useAppContext } from '../../../store/App/utils/useAppContext';
import {
  startChat,
  startChatFail,
  updateChat,
} from '../../../store/transcript/actions';
import { useTranscriptContext } from '../../../store/transcript/utils/useTranscriptContext';

/**
 * Initialize Chat Session
 */
export const useStartChat = () => {
  const {
    dispatch,
    state: { sessionId, isSessionActive },
  } = useTranscriptContext();
  const {
    endpoints,
    state: { systemId, tenantId, userId, isPublicAnonymousUser },
  } = useAppContext();

  useEffect(() => {
    /**
     * Initialize Chat Session
     * Public anonymous widget users have no userId but are a fully resolved
     * identity, so they are allowed to start a session.
     */
    if (systemId && tenantId && (userId || isPublicAnonymousUser) && !isSessionActive) {
      const endpointConfig = { systemId, tenantId, userId, isPublicAnonymousUser };
      const initPromise = !sessionId
        ? endpoints.initChat(endpointConfig)
        : endpoints.resumeChat?.(endpointConfig, sessionId) ??
          endpoints.initChat(endpointConfig);

      dispatch(startChat());
      initPromise
        .then((d) => {
          dispatch(updateChat(d));
        })
        .catch(() => {
          dispatch(startChatFail());
        });
    }
  }, [
    dispatch,
    endpoints,
    isSessionActive,
    sessionId,
    systemId,
    tenantId,
    userId,
    isPublicAnonymousUser,
  ]);
};
